import {
  Stack,
  Heading,
  Columns,
  Column,
  TextField,
} from 'braid-design-system';

import type { DetailsProps } from './Form';
import { useFormFields } from './useFormFields';

export const PersonalDetails = ({ setFieldValue }: DetailsProps) => {
  const { firstName, lastName, jobTitle, phone, email } = useFormFields();

  return (
    <Stack space="medium">
      <Heading level="3">Personal details</Heading>
      <Columns space="gutter">
        <Column>
          <TextField
            id="firstName"
            label="First name"
            message={!firstName.valid && firstName.errorMessage}
            onClear={() => setFieldValue('firstName', '')}
            tone={!firstName.valid ? 'critical' : 'neutral'}
            {...firstName}
          />
        </Column>
        <Column>
          <TextField
            id="lastName"
            label="Last name"
            message={!lastName.valid && lastName.errorMessage}
            onClear={() => setFieldValue('lastName', '')}
            tone={!lastName.valid ? 'critical' : 'neutral'}
            {...lastName}
          />
        </Column>
      </Columns>
      <TextField
        id="jobTitle"
        label="Job title"
        message={!jobTitle.valid && jobTitle.errorMessage}
        onClear={() => setFieldValue('jobTitle', '')}
        tone={!jobTitle.valid ? 'critical' : 'neutral'}
        {...jobTitle}
      />
      <TextField
        id="phone"
        label="Phone"
        message={!phone.valid && phone.errorMessage}
        onClear={() => setFieldValue('phone', '')}
        tone={!phone.valid ? 'critical' : 'neutral'}
        {...phone}
      />
      <TextField
        id="email"
        label="Email"
        onClear={() => setFieldValue('email', '')}
        message={!email.valid && email.errorMessage}
        tone={!email.valid ? 'critical' : 'neutral'}
        {...email}
      />
    </Stack>
  );
};
